import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.49243 8.91302C1.20151 8.71452 1.20151 8.28548 1.49243 8.08698L12.0451 0.886646C12.377 0.660191 12.8269 0.897873 12.8269 1.29966L12.8269 15.7003C12.8269 16.1021 12.377 16.3398 12.0451 16.1134L1.49243 8.91302Z"
      stroke="currentColor"
    />
  </svg>,
  "ArrowPreviousMapCarousel"
);
